import brand from '@/api/brand';

const APPEND_BRANDS = 'APPEND_BRANDS';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_IS_ALL = 'SET_IS_ALL';
const ADD_PAGE = 'ADD_PAGE';
const RESET_BRANDS = 'RESET_BRANDS';
const SET_PAGE_INFO = 'SET_PAGE_INFO';

const state = {
	all: [],
	isFetching: false,
	isAll: false,
	page: 1,
	isFetched: false,
	pageInfo: null,
};

const getters = {
	allBrands: state => state.all,
	isFetching: state => state.isFetching,
	isAll: state => state.isAll,
	page: state => state.page,
	isFetched: state => state.isFetched,
	pageInfo: state => state.pageInfo,
};

const mutations = {
	[APPEND_BRANDS](state, brands) {
		state.all = state.all.concat(brands);
	},
	[RESET_BRANDS](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_IS_ALL](state, status) {
		state.isAll = status;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_PAGE_INFO](state, pageInfo) {
		state.pageInfo = pageInfo;
	},
};

const actions = {
	getBrands({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				console.log(response);
				const brands = response.data.brands ? response.data.brands : response.data;
				if (response.data.page_info) {
					const pageInfo = response.data.page_info;
					commit(SET_PAGE_INFO, pageInfo);
				}
				if (brands.length !== 0) {
					commit(APPEND_BRANDS, brands);
					commit(ADD_PAGE);
				} else {
					commit(SET_IS_ALL, true);
				}
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHED, true);
			};
			brand.getBrands(params, callback, errorCallback);
		}
	},
	resetBrands({ commit }) {
		commit(RESET_BRANDS);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
